import { render, staticRenderFns } from "./VImportResultModal.vue?vue&type=template&id=f10b0d46&"
import script from "./VImportResultModal.vue?vue&type=script&lang=js&"
export * from "./VImportResultModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports